import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Corsi() {
    return (
        <div className="content">
            <PageLabelBar title="I tuoi Corsi" />
        </div>
    );
}